import React, { useEffect, useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import './payments.css'
import { Col, Row } from 'react-bootstrap'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import PaymentsService from '../../services/payments.service'
import { useTranslation } from 'react-i18next'
import config from 'custom/config/environment'

export default function BillerServicesView() {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()
  const [billerList, setBillerList] = useState([])

  useEffect(() => {
    if (location?.state === undefined || location?.state === null) {
      history.push('/payments')
      return
    }
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const { categoryDetails } = location.state
      const response = await PaymentsService.getAllBillers({
        fetchServices: true,
        fetchProducts: false,
        module: 'PAYMENT',
      })
      if (response.status === 200) {
        let serviceDetails = response.data['categories'].filter(
          (ele) => ele.category === categoryDetails.category,
        )[0].services
        serviceDetails.forEach((element) => {
          element.title = element.description
          element.icon = element.logo
          element.key = element.serviceId
        })
        setBillerList(serviceDetails)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  return (
    <LayoutWithAccountCard
      pageTitle={location?.state?.categoryDetails?.description}
      breadCumKey='BILLER_SERVICES_VIEW'>
      <Row>
        {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() =>{
              history.push({
                pathname: (option.category === "SCHOOLPAY" && config.CLIENT_NAME === 'NBS')?'/payments/services/school/product':'/payments/services/product',
                state: { billerDetails: option },
              })
            }

              // history.push({
              //   pathname: '/payments/services/product',
              //   state: { billerDetails: option },
              // })
            }>
            <img width={52} height={40} src={option?.icon} />
            <h2>{t(option?.description)}</h2>
          </Col>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
